import { Slide } from "@mui/material";
import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import "./banner.css";
import { FaAngleRight } from "react-icons/fa";
import { AiFillShopping } from "react-icons/ai";
import { ImFire } from "react-icons/im";
import { BannerSkeleton } from "./AllCategory/Skeleton";
import { MyContextSupply } from "../../Context";
import { NavLink } from "react-router-dom";
import axios from "axios";

const Banner = () => {
  const { toggleRunPath, setSingleProductPathId, handleAddProduct } =
    MyContextSupply();
  const [bestSellerData, setBestSellerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCursorEnter, setIsCusorEnter] = useState(false);

  // getting best seller data
  const getBestSellerData = async () => {
    setLoading(true);
    await axios
      .get("https://stechbackend-9r4c.onrender.com/getbestseller")
      .then((res) => {
        if (res.status === 200) {
          setBestSellerData(res.data);
          const auto = setTimeout(() => {
            setLoading(false);
          }, 500);
          return () => {
            clearTimeout(auto);
          };
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getBestSellerData();
  }, []);
  return (
    <Carousel
      className="carasousel"
      autoPlay={true}
      animation="slide"
      duration={500}
      indicators={false}
      navButtonsAlwaysVisible={true}
      cycleNavigation={true}
      swipe={true}
      navButtonsProps={{
        style: {
          background: "white",
          color: "red",
          borderRadius: 100,
          marginTop: -22,
          height: "80px",
        },
      }}
    >
      {loading ? (
        <BannerSkeleton />
      ) : (
        bestSellerData.map((singleData) => {
          // console.log(singleData)
          const {
            url,
            title: { shortTitle },
            price: { mrp, cost },
            _id: id,
          } = singleData;
          // console.log(singleData);
          let discount = ((mrp - cost) / mrp) * 100;
          if (discount % 1 === 0) {
            discount = parseInt(discount);
          } else {
            discount = discount.toFixed(2);
          }
          return (
            <div
              onMouseEnter={() => setIsCusorEnter(true)}
              onMouseOut={() => setIsCusorEnter(false)}
              key={id}
              className="banner_div"
            >
              <div
                className={`best-seller-p-banner ${
                  isCursorEnter ? "" : "best-seller-animation"
                }`}
              >
                <div className="icon-pos-rel-banner">
                  <ImFire className="icon-best-banner" />
                  <p>Hot Sale</p>
                </div>
              </div>
              <div className="img-banner-div">
                <img
                  src={url}
                  alt=""
                  className={`banner_img ${
                    isCursorEnter ? "" : "new-image-animation"
                  }`}
                  onMouseEnter={() => setIsCusorEnter(true)}
                />
              </div>
              <div
                onMouseEnter={() => setIsCusorEnter(true)}
                className="pos-relative-banner-titles"
              >
                <div>
                  <h2
                    onMouseEnter={() => setIsCusorEnter(true)}
                    className={`title-banner  ${
                      isCursorEnter ? "" : "title-banner-ani"
                    }`}
                  >{`${
                    shortTitle.length > 17
                      ? shortTitle.slice(0, 17)
                      : shortTitle
                  }${shortTitle.length > 17 ? "..." : ""}`}</h2>
                  <div className="banner-div-price-discount">
                    <h1
                      className={`${isCursorEnter ? "" : "cost_banner"}`}
                      onMouseEnter={() => setIsCusorEnter(true)}
                    >
                      Only {cost}$
                    </h1>
                    <h4 onMouseEnter={() => setIsCusorEnter(true)}>
                      {discount}% discount
                    </h4>
                  </div>
                  <div className="banner-btn-div">
                    <div>
                      <NavLink
                        to={`/getproductsone/${id}`}
                        className="banner-navlink-btn"
                        onMouseEnter={() => setIsCusorEnter(true)}
                      >
                        <button
                          onClick={() => {
                            toggleRunPath();
                            setSingleProductPathId(id);
                          }}
                          className="btn-banner-one"
                        >
                          Detalis
                          <FaAngleRight className="banner-btn-one-icon" />
                        </button>
                      </NavLink>
                    </div>
                    <div>
                      <NavLink to="/buynow">
                        <button
                          onClick={() => {
                            handleAddProduct(singleData);
                            toggleRunPath();
                          }}
                          onMouseEnter={() => setIsCusorEnter(true)}
                          className="btn-banner-one"
                        >
                          Buy Now
                          <AiFillShopping className="banner-btn-one-icon" />
                        </button>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </Carousel>
  );
};

export default Banner;
